/**
 * 換算の設定値の数値を、文字列のまま扱う。
 * 浮動小数点数に変換すると桁が変わり、入力した値・DB の値と食い違うため、Number() や parseFloat() は使わない。
 */

/** 前後の空白（Unicode の White_Space）。String.prototype.trim と \s は対象が違うため使わない */
const LEADING_SPACE = /^\p{White_Space}+/u;
const TRAILING_SPACE = /\p{White_Space}+$/u;

export function trimWhiteSpace(value: string): string {
  return value.replace(LEADING_SPACE, '').replace(TRAILING_SPACE, '');
}

/** `0` か、`0` 以外の半角の数字で始まる半角の数字の並び。小数点と1つ以上の数字が続いてもよい */
const NUMBER_FORMAT = /^(0|[1-9][0-9]*)(\.[0-9]+)?$/;

export type NumberCheck = { ok: true; canonical: string } | { ok: false; blank: boolean };

/**
 * 入力値が数値の形式かを判定する。形式どおりなら、同じ値が同じ文字列になる形（小数点以下の末尾の0を除いた形）を返す。
 */
export function parseNumberInput(input: string): NumberCheck {
  const value = trimWhiteSpace(input);
  if (value === '') return { ok: false, blank: true };
  if (!NUMBER_FORMAT.test(value)) return { ok: false, blank: false };
  return { ok: true, canonical: canonical(value) };
}

function canonical(value: string): string {
  const [int, frac = ''] = value.split('.');
  const trimmed = frac.replace(/0+$/, '');
  return trimmed ? `${int}.${trimmed}` : int;
}

/**
 * 表示用に整える。小数点以下の末尾の0と、それで残った小数点を除き、整数部を3桁ごとにカンマで区切る。
 */
export function formatNumber(value: string): string {
  const negative = value.startsWith('-');
  const [int, frac = ''] = (negative ? value.slice(1) : value).split('.');
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const trimmed = frac.replace(/0+$/, '');
  return `${negative ? '-' : ''}${grouped}${trimmed ? `.${trimmed}` : ''}`;
}
